export default "__VITE_ASSET__f7hPDPSW__"